import { AgentLicensePlanAgentBundle } from './agent-license-plan-agent-bundle';
import { AgentLicensePlanChange } from './agent-license-plan-change';
import { LicensePlan } from './license-plan';

export class AgentLicensePlan {
	public id: number;
	public agentId: string;
	public licensePlanId: number;
	public quantity: number;
	public termStartDate: string;

	public licensePlan: LicensePlan;
	public agentBundles: AgentLicensePlanAgentBundle[];
	public pendingChange: AgentLicensePlanChange;

	constructor(agentLicensePlan: AgentLicensePlan) {
		Object.assign(this, agentLicensePlan);

		this.licensePlan = agentLicensePlan.licensePlan ? new LicensePlan(agentLicensePlan.licensePlan) : null;
		this.pendingChange = agentLicensePlan.pendingChange ? new AgentLicensePlanChange(agentLicensePlan.pendingChange) : null;
	}
}
